class BlogFilter extends HTMLElement {
  // 페이지 첫 select(예: 지역 팝업 국가 선택)가 아니라 이 필터 안의 select만 잡는다
  // Bind only this filter's own select, not the page's first one (e.g. the region modal's country select)
  connectedCallback() {
    const filter = this.querySelector('select');
    if (!filter) return;

    filter.addEventListener('change', () => {
      window.location.href = filter.value;
    });
  }
}

customElements.define('blog-filter', BlogFilter);

// 모바일 "더 보기" 텍스트 링크: 누를 때마다 숨긴 카드를 step 개씩 펼치고, 이 페이지 카드가 떨어지면 다음 페이지 카드를 불러와 붙인다
// Mobile "Show more" text link: each tap reveals `step` hidden cards, fetching the next page's cards once this page runs out
class BlogShowMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.grid = document.getElementById(this.dataset.target);
    this.step = parseInt(this.dataset.step, 10);
    this.nextUrl = this.dataset.nextUrl;
    this.onClick = this.showMore.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onClick);
  }

  hiddenCards() {
    return [...this.grid.querySelectorAll('.blog-articles__article--mobile-more')];
  }

  async showMore() {
    if (this.button.getAttribute('aria-busy') === 'true') return;

    if (this.hiddenCards().length === 0 && this.nextUrl) {
      this.button.setAttribute('aria-busy', 'true');
      try {
        await this.appendNextPage();
      } catch (error) {
        // 불러오기에 실패하면 일반 페이지 이동으로 대신한다 / If loading fails, fall back to a normal page visit
        window.location.href = this.nextUrl;
        return;
      }
      this.button.removeAttribute('aria-busy');
    }

    const revealed = this.hiddenCards().slice(0, this.step);
    revealed.forEach((card) => card.classList.remove('blog-articles__article--mobile-more'));
    if (revealed.length) revealed[0].querySelector('a').focus();

    if (this.hiddenCards().length === 0 && !this.nextUrl) this.remove();
  }

  async appendNextPage() {
    // 섹션 렌더링 API로 이 섹션만 받아온다 / Fetch only this section via the Section Rendering API
    const url = new URL(this.nextUrl, window.location.origin);
    // 다음 페이지 URL에 없는 현재 쿼리(예: ?view=)는 이어 붙여 같은 템플릿으로 렌더되게 한다
    // Carry over current query params the next URL lacks (e.g. ?view=) so the same template renders
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    url.searchParams.set('section_id', this.dataset.sectionId);
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    page.querySelectorAll('.blog-articles__article').forEach((card) => {
      card.classList.add('blog-articles__article--mobile-more');
      this.grid.appendChild(card);
    });
    this.nextUrl = page.querySelector('blog-show-more')?.dataset.nextUrl || '';
  }
}

customElements.define('blog-show-more', BlogShowMore);
